/**
 * What the assistant panel says when a turn does not arrive.
 *
 * A dropped connection surfaces as the browser's own words, and each browser
 * has different ones — "Failed to fetch", "network error", "Load failed",
 * "NetworkError when attempting to fetch resource". None of them tells the
 * person whether anything was done or what to do next, so they are answered in
 * the app's words instead. An error the server phrased is passed through as it
 * is: that one was written to be read.
 */
const NETWORK = [
  /failed to fetch/i,
  /network ?error/i,
  /load failed/i,
  /error in input stream/i,
  /the network connection was lost/i,
]

export const CONNECTION_LOST =
  'The connection dropped before the assistant answered. Nothing was changed — send it again.'

export const TURN_MISSING =
  'The assistant stopped before finishing its answer. Nothing was changed — send it again.'

export function assistantFailure(err: unknown): string {
  const message = err instanceof Error ? err.message : String(err)
  if (!message.trim()) return CONNECTION_LOST
  return NETWORK.some((p) => p.test(message)) ? CONNECTION_LOST : message
}
